import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CheckDTO, PreviousCheckDTO } from "../../../../models/check-interface";
import { CheckStorageService } from '../../../../services/check-storage.service';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'lib-previous-check-tab',
  templateUrl: './previous-check-tab.component.html',
  styleUrls: ['./previous-check-tab.component.scss']
})
export class PreviousCheckTabComponent implements OnChanges, AfterViewInit {

  @Input() previousCheck!: PreviousCheckDTO;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  constructor(
    private cdr: ChangeDetectorRef,
    public checkStorageService: CheckStorageService,
    
  ) { 
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.previousCheck && changes.previousCheck.currentValue) {
      delete this.previousCheck;
      this.previousCheck = changes.previousCheck.currentValue;
      this.cdr.detectChanges();
    }
  }
  ngAfterViewInit(): void {
    this.restoreScrollPosition();
  }

  onScroll(event: any): void {
    this.checkStorageService.scrollPosition = event.target.scrollTop;
  }
  
  restoreScrollPosition(): void {
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      setTimeout(() => {
        this.scrollContainer.nativeElement.scrollTop = this.checkStorageService.scrollPosition;
      }, 0);
    }
  }
  
}
